import { render } from "./IconMore.vue?vue&type=template&id=3ef27140"
import script from "./IconMore.vue?vue&type=script&lang=ts"
export * from "./IconMore.vue?vue&type=script&lang=ts"
script.render = render

export default script